import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from './../../../projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { DataService } from './../../../projects/Autofacets-Core/src/app/services/data.service';
import { ToastrMessages } from 'projects/Autofacets-Core/src/app/utils/enums';
import { environment } from 'projects/Administration/src/environments/environment';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgxSpinnerService } from 'ngx-spinner';
@Injectable({ providedIn: 'root' })


export class UserDataService {
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  userDetails: any;
  userLogOut:boolean=false;
  isDealerLoggedIn: boolean=false;
  isReceptionLoggedIn:boolean=false;
  userStampIn:Date;
  public feature:any
  // currentUserRoleDetails: UserRoleMenu[];
  private apiBaseUrl = environment.ADMIN_API_URL;

  constructor(
    private dataProvider: DataService,
      private secureService: SecureStorage,
      private baseService: BaseService,
      private toaster: ToastrService,
      private spinner: NgxSpinnerService,
    private router: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(this.secureService.getKeyData('currentUser'));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  async GetUserDetails() {
    const userData = this.secureService.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
    this.userStampIn = null;
    if (userData) {
      localStorage.setItem(Constant.UserLoggedId, 'true')
      this.currentUserSubject.next(userData);
      this.isDealerLoggedIn =this.currentUserSubject.value.roleType === fromEnums.UserRoles.DealerAdmin;
      this.isReceptionLoggedIn = this.currentUserSubject.value.roleType === fromEnums.UserRoles.Reception;
      this.userStampIn = userData.stampIn;
      return userData;
    }
    else{
      return this.dataProvider.Get<any>(this.apiBaseUrl + 'Login/UserDetails')
      .toPromise().then(res => {
        if (res && !res?.responseCode) {
          localStorage.setItem(Constant.UserLoggedId, 'true')
          this.secureService.setKeyData(fromEnums.SecureStorageKey.GetUserDetails, res);
          this.currentUserSubject.next(res);
          this.isDealerLoggedIn =this.currentUserSubject.value.roleType === fromEnums.UserRoles.DealerAdmin;
          this.isReceptionLoggedIn = this.currentUserSubject.value.roleType === fromEnums.UserRoles.Reception;
          this.userStampIn =  res.stampIn;
        }
        else if (res && res?.responseCode == 401) {
          this.toaster.error(ToastrMessages.UnAuthorizedError);
        }
        return res;
      }).catch(_err => {
        this.toaster.error(_err.message);
      });
    }
  }
  async SetLoginActivity(isLoggedId:boolean,ipAddress:string,routeUrl:string){
    return this.dataProvider.GetNonEnc(this.apiBaseUrl + 'Login/SetLoginActivity',isLoggedId,ipAddress,routeUrl)
      .toPromise().then(res => {
        if (res && !isLoggedId) {
          this.baseService.signout();
        }
        return res;
      });
  }

  public routeUnAuthorizedAccess() {
    return this.router.navigate(['/auth/error']);
  }

  public setUserStampInOut(isStampIn = false) {
    this.spinner.show();
    let registerUserStamp;
    if (isStampIn) {
      const userData = this.secureService.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
      registerUserStamp = {
        userId: userData.userId,
        createdBy: userData.userId,
        stampIn: Utility.ConvertLocalDateToUTCDate(new Date())
      }
    } else {
      const userData = this.secureService.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
      registerUserStamp = {
        userId: userData.userId,
        createdBy: userData.userId,
        stampOut: Utility.ConvertLocalDateToUTCDate(new Date())
      }
    }
    this.dataProvider.Post<any>(this.apiBaseUrl + 'UserStampInOut/RegisterUserStamp', registerUserStamp)
    .toPromise().then(async res => {
      this.secureService.removeKey(fromEnums.SecureStorageKey.GetUserDetails);
      await this.GetUserDetails();
      if (!isStampIn) {
        this.router.navigate(['/dashboard']);
      }
      this.spinner.hide();
    }).catch(err => {
      this.spinner.hide();
    })
  }

}
